import Root from "./components/Root";


function App() {
  return (
    <div>
        <Root/>
    </div>
  );
}

export default App;
